import React from "react";
import { Checkbox, Typography, Box } from "@mui/material";
import { generateGuid } from 'helpers';
import { useTranslation } from 'react-i18next';
import { Controller } from "react-hook-form";
import { TooltipCustom } from 'components/common';


export default function FormInputCheckbox (props) {
  const {
    position='horizontal',
    name,
    control,
    label,
    disabled=false,
    size='medium',
    defaultValue=false,
    className,
    helperText,
    onChange
  } = props;

  const [t, i18n] = useTranslation();
  const defaultId = !props?.id && `textfield-${generateGuid()}`;
  const onChangeCustom = onChange;
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: position === 'vertical' ? 'column' : 'row',
      alignItems: position === 'vertical' ? 'flex-start' : 'center'
    }}>
      <Controller
        id={defaultId}
        name={name ?? defaultId}
        control={control}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => (
          <Checkbox
            size={size ? size : 'medium'}
            onChange={ (event) => {
              //event.preventDefault();        
              onChange(event);
              if (onChangeCustom) {
                onChangeCustom(event);
              }
            }}
            value={value}
            checked={value}
            disabled={disabled}
            className={className}
          />
        )}
      />
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}>
        <Typography
          variant="subtitle1"
          id={`label-title-${defaultId}`}
        >
          { i18n.exists(label) ? t(label) : label }
        </Typography>
        { helperText && <TooltipCustom title={helperText}/> }
      </Box>
    </Box>
  );
};
